import { TestimonialDto } from '@app/models/dtos/contentDto';

const testimonials: TestimonialDto[] = [
    {
        id: 'sandip',
        quote: 'Nabin is a disciplined guy who delivered the assigned tasks within the deadline with a fantastic result. I highly recommend Nabin as a software engineer and would love to work together again.',
        name: 'Sandip Pandey',
        position: 'CEO, Sireto Technology',
        image: 'https://nabinkawan.github.io/bucket/portfolio/images/testimonials/sandip.png'
    }
];

export default testimonials;
